import useSWR from 'swr'
import { endpoints, request } from '.'

export const useCtas = () => {
  const { data, isLoading, isValidating, error } = useSWR(
    endpoints.ctas.read(),
    request
  )

  return {
    availableCtas: data?.data?.data,
    isLoading,
    isValidating,
    error,
  }
}
